module.exports = __webpack_public_path__ + "img/2021_2_21_beach_monster.19d924f8.jpg";